export const env = {
  defaultLanguage: 'tr-TR',
  availableLangs: [
    { id: 'tr-TR', label: 'TR' },
    { id: 'en-US', label: 'EN' }
  ],

  defaultsConfig: {
    projectName: 'Enerji Doktoru',
    company: 'ENTES Elektronik Cihazlar İmalat ve Ticaret A.Ş.',
    logo: 'logo.png',
    numberFormatOptions: { maximumFractionDigits: 2, minimumFractionDigits: 1 },
  }
};
